export const FIRST_LEVEL_NAV_HEIGHT = 72;
export const SECOND_LEVEL_NAV_HEIGHT = 60;
export const THIRD_LEVEL_NAV_HEIGHT = 60;
